import { Box } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { CSSProperties } from "react";
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import theme from "src/theme/light";
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";

interface InputPrefixProps {
  styles?: CSSProperties
}

export function InputPrefix({ styles = {} }: InputPrefixProps){
  const { changeModalsValue } = useProjetosHibridoStore(store => store.actions);

  return (
    <Box
      onClick={() => changeModalsValue({ drawerInformacoes: true })}
      component={"button"}
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      border={"none"}
      bgcolor={"transparent"}
      style={{ cursor: 'pointer', outline: 'none', ...styles }}
      >
        <InfoOutlined
          htmlColor={theme.palette.grey[600]}
          fontSize={"small"}
        />
    </Box>
  )
}